<template>
	<div class="approvalHistoryWrap">
		<QueryHeader @queryData="handleQueryData"></QueryHeader>
		<div class="exportWrap">
			<el-button
				type="primary"
				icon="el-icon-download"
				@click="exportClick()"
				>导出
			</el-button>
		</div>
		<TableContent
			:tableData="tableData"
			left-action-btn="取消审批"
			right-action-btn="详情"
			@actionBtnClick="tableActionClick"
		></TableContent>
		<PageFooter
			:totalCount="totalCount"
			:pageIndex="pageIndex"
			:pageSize="pageSize"
			@pageChange="handlePageChange"
		></PageFooter>
		<DialogPage
			:visible="dialogVisible"
			:itemId="itemId"
			:type="type"
			@updateVisible="updateDialogVisible"
		></DialogPage>
	</div>
</template>

<script>
import QueryHeader from "../components/query";
import TableContent from "../components/table";
import PageFooter from "../components/page";
import DialogPage from "../components/dialog";
import {
	getWorkBenchAuditHistoryListApi,
	exportWorkBenchAuditHistoryListApi,
} from "../../../services/workbenchServices";
import { exportExcelService2 } from "../../../services/allContractServices";
import { getRouteIdByType } from "../../approveComponents/approve";

export default {
	name: "pendingApproval",
	components: { QueryHeader, TableContent, PageFooter, DialogPage },
	data() {
		return {
			queryParams: {}, //查询条件
			pageIndex: 1,
			pageSize: 10,
			totalCount: 0,
			tableData: [],
			dialogVisible: false,
			itemId: "",
			type: "",
		};
	},
	created() {
		this.queryData();
        this.bus.$on("headerActiveTabName", (item) => {
            if (item === "审批历史") {
                this.queryData();
            }
        });
	},
	methods: {
		handleQueryData(params) {
			this.queryParams = params;
			this.pageIndex = 1;
			this.queryData();
		},
		handlePageChange(data) {
			this[data.type] = data.value;
			this.queryData();
		},
		queryData() {
			const params = {
				...this.queryParams,
				pageIndex: this.pageIndex,
				pageSize: this.pageSize,
			};
			getWorkBenchAuditHistoryListApi(params)
				.then((res) => {
					if (res.code == 10000000) {
						this.tableData = res.data || [];
						this.totalCount = res.total || 0;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch(() => {
					this.$message.error("网络请求失败");
				});
		},

		tableActionClick(data) {
			const { btnName, row } = data;
			if (btnName == "取消审批") {
				this.itemId = row.itemId;
				this.type = row.type;
				this.dialogVisible = true;
			} else {
				this.bus.$emit("navMenuChange", {
					routeId: getRouteIdByType(row.type),
					routeParam: {
						//approveFlag currentApprove  审批项目  waitApproveDetail    待审批列表进审批详情    historyApproveDetail 审批历史列表进审批详情
						approveFlag: "historyApproveDetail",
						id: row.itemId,
						approveType: row.type
					},
				});
			}
		},
		exportClick() {
			exportWorkBenchAuditHistoryListApi(this.queryParams)
				.then((res) => {
					if (res.code == 10000000) {
						exportExcelService2(res.data).then((res1) => {
							this.$alert("导出成功", "提示", {
								confirmButtonText: "确定",
							});
						});
					} else if (res.code >= 10000000) {
						this.$alert(res.msg, "提示", {
							confirmButtonText: "确定",
						});
					} else {
						this.$alert("系统异常", "提示", {
							confirmButtonText: "确定",
						});
					}
				})
				.catch(() => {
					this.$message.error("网络请求失败");
				});
		},
		updateDialogVisible(data) {
			this.dialogVisible = data.val;
			if (data?.isQuery) {
				this.queryData();
			}
		},
	},
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";

.approvalHistoryWrap {
	height: 100%;
	background-color: white;
	padding: 16px;

	.exportWrap {
		text-align: right;
		margin: 16px 0;
	}
}
</style>
